module.exports = __webpack_public_path__ + "img/ron_s_2.07580aa1.png";